import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Custom
import CollapseBoxTemplate from 'components/templates/CollapseBoxTemplate';
import { ClearFiltersIconButton, BasicFiltersIconButton, AdvancedFiltersIconButton } from 'components/buttons/IconButtons';

const FiltersTemplate = ({
  disabled, advanced, nbFiltersApplied, children, onReinit, onSwitch,
}) => {
  const [open, setOpen] = React.useState(true);

  const handleExpandChange = (op) => {
    setOpen(op);
  };

  const buttons = [];
  if (nbFiltersApplied > 0) {
    buttons.push(
      <ClearFiltersIconButton
        key="bReinit"
        disabled={disabled}
        primary
        onClick={onReinit}
      />,
    );
  }
  if (open) {
    if (advanced) {
      buttons.push(
        <BasicFiltersIconButton
          key="bSwitch"
          disabled={disabled}
          primary
          onClick={onSwitch}
        />,
      );
    } else {
      buttons.push(
        <AdvancedFiltersIconButton
          key="bSwitch"
          disabled={disabled}
          primary
          onClick={onSwitch}
        />,
      );
    }
  }

  return (
    <div className="mb-4">
      <CollapseBoxTemplate
        title={<LocalizedMessage id="title.filters" />}
        numericValue={nbFiltersApplied > 0 ? nbFiltersApplied : null}
        titleSize="sm"
        buttons={buttons}
        buttonsXsNewLine
        onExpandChange={handleExpandChange}
      >
        { children }
      </CollapseBoxTemplate>
    </div>
  );
};

FiltersTemplate.propTypes = {
  disabled: PropTypes.bool.isRequired,
  advanced: PropTypes.bool.isRequired,
  nbFiltersApplied: PropTypes.number.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
  onReinit: PropTypes.func.isRequired,
  onSwitch: PropTypes.func.isRequired,
};

module.exports = FiltersTemplate;



// WEBPACK FOOTER //
// ./components/templates/FiltersTemplate.js